import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { InsuranceActionTypes } from "./Insurance.type";

export function* fetchAllInsurances(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/insurance`);
    yield put({
      type: InsuranceActionTypes.FETCH_ALL_INSURANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: InsuranceActionTypes.FETCH_ALL_INSURANCE_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneInsurances(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/insurance/${action.payload}`
    );
    yield put({
      type: InsuranceActionTypes.FETCH_ONE_INSURANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: InsuranceActionTypes.FETCH_ONE_INSURANCE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllInsurances() {
  yield takeLatest(
    InsuranceActionTypes.FETCH_ALL_INSURANCE,
    fetchAllInsurances
  );
}

export function* watcherFetchOneInsurances() {
  yield takeLatest(
    InsuranceActionTypes.FETCH_ONE_INSURANCE,
    fetchOneInsurances
  );
}
